module.exports = "/_next/static/images/bch-440f66c590d5f3dd396f20f40be222d9.svg";